namespace $ {

	export type $shm_ba_data_connection = Awaited< ReturnType< ReturnType< typeof $shm_duckdb.db >['connect'] > >
	const $shm_ba_data_filter_started_at = new WeakMap< $shm_ba_data, { date: Date, time: number } >()

	export class $shm_ba_data extends $mol_object2 {

		app_id() {
			return ''
		}

		file(): File | null {
			return null
		}

		file_uri() {
			return ''
		}

		file_token() {
			return ''
		}

		period(): $shm_ba_data_period {
			return {
				from: '0001-01-01',
				to: '2999-12-31',
			}
		}

		tags_filter(): $shm_ba_data_filter {
			return {}
		}

		authors_filter(): $shm_ba_data_filter {
			return {}
		}

		sources_filter(): $shm_ba_data_filter {
			return {}
		}

		message_types_filter(): $shm_ba_data_filter {
			return {}
		}

		source_types_filter(): $shm_ba_data_filter {
			return {}
		}

		search_query() {
			return ''
		}

		search_mode(): $shm_ba_data_search_mode {
			return 'fts'
		}

		search_case_sensitive() {
			return true
		}

		chart_metric() {
			return 'Сообщений'
		}

		summary_indicators(): readonly string[] {
			return [
				'Сообщения',
				'Авторы',
				'Источники',
				'Аудитория',
				'Просмотры',
				'Комментарии',
				'Вовлеченность',
				'Лайки',
				'Репосты',
				'Аудитория СМИ',
				'Цитируемость СМИ',
			]
		}

		chart_group(): $shm_ba_chart_group {
			return 'day'
		}

		posts_sort() {
			return 'Дата'
		}

		posts_sort_order() {
			return 'desc'
		}

		sql_ident( name: string ) {
			return '"' + String( name ).replaceAll( '"', '""' ) + '"'
		}

		sql_text( text: unknown ) {
			return "'" + String( text ).replaceAll( "'", "''" ) + "'"
		}

		sql_like_pattern( text: unknown ) {
			const escaped = String( text )
				.replaceAll( '$', '$$' )
				.replaceAll( '%', '$%' )
				.replaceAll( '_', '$_' )
			return this.sql_text(
				`%${ escaped }%`,
			)
		}

		audience_message_condition( alias: string ) {
			return `${ alias }."Тип сообщения" IS DISTINCT FROM ${ this.sql_text( 'Комментарий' ) }`
		}

		resource_name( name: string ) {
			return `${ name }_${ this.app_id().replaceAll( /[^a-zA-Z0-9_]/g, '_' ) }`
		}

		file_db_name() {
			return `${ this.resource_name( 'ba_file' ) }_${ this.file_name() }`
		}

		local_file_prefix() {
			return `hitalama-ba-csv:${ this.app_id() }:`
		}

		local_file_key() {
			return `${ this.local_file_prefix() }${ this.file_name() }`
		}

		file_extension() {
			const name = this.file_name().split( '?' )[0].toLowerCase()
			const match = name.match( /\.([^.\/\\]+)$/ )
			return match?.[1] ?? 'csv'
		}

		file_is_duckdb() {
			const ext = this.file_extension()
			return ext === 'duckdb' || ext === 'db'
		}

		file_buffer_has_text( buffer: ArrayBuffer, text: string, from = 0, to = 64 ) {
			const bytes = new Uint8Array( buffer, 0, Math.min( buffer.byteLength, to ) )
			const codes = [ ... text ].map( char => char.charCodeAt( 0 ) )
			for( let offset = from; offset <= bytes.length - codes.length; ++ offset ) {
				if( codes.every( ( code, index )=> bytes[ offset + index ] === code ) ) return true
			}
			return false
		}

		file_buffer_valid( buffer: ArrayBuffer ) {
			const ext = this.file_extension()
			if( ext === 'parquet' ) return this.file_buffer_has_text( buffer, 'PAR1', 0, 4 )
			if( ext === 'duckdb' || ext === 'db' ) return this.file_buffer_has_text( buffer, 'DUCK' )
			return true
		}

		messages_table_name() {
			return this.resource_name( 'ba_messages' )
		}

		duckdb_import_db_name() {
			return this.resource_name( 'ba_import' )
		}

		raw_table_name() {
			return this.resource_name( 'ba_messages_raw' )
		}

		tags_table_name() {
			return this.resource_name( 'ba_message_tags' )
		}

		filtered_table_name() {
			return this.resource_name( 'ba_messages_filtered_ids' )
		}

		period_table_name() {
			return this.resource_name( 'ba_messages_period_ids' )
		}

		@ $mol_mem_key
		duckdb_import_has_table( name: string ) {
			if( !this.file_is_duckdb() ) return false
			const conn = this.data_connection()
			const table = $mol_wire_sync( conn ).query( `
				SELECT COUNT(*) AS "count"
				FROM information_schema.tables
				WHERE table_catalog = ${ this.sql_text( this.duckdb_import_db_name() ) }
					AND table_schema = 'main'
					AND table_name = ${ this.sql_text( name ) };
			` )
			return Number( table.getChild( 'count' )?.get( 0 ) ?? 0 ) > 0
		}

		tags_table_ref( table_name: string, conn: $shm_ba_data_connection ) {
			if( !this.duckdb_import_has_table( 'ba_message_tags' ) ) return this.tags_table_name()
			const tags = this.tag_names( table_name, conn )
			const source = `${ this.sql_ident( this.duckdb_import_db_name() ) }.main.ba_message_tags`
			if( !tags.length ) return `( SELECT "_ID", "Тег" FROM ${ source } WHERE FALSE )`
			return `( SELECT "_ID", "Тег" FROM ${ source } WHERE "Тег" IN ( ${ tags.map( tag => this.sql_text( tag ) ).join( ', ' ) } ) )`
		}

		fts_schema_name() {
			if( !this.file_is_duckdb() ) return `fts_main_${ this.messages_table_name() }`
			return `fts_main_${ this.duckdb_import_table_name( this.data_connection() ) }`
		}

		fts_match_ref() {
			const fts_schema_name = this.fts_schema_name()
			if( this.file_is_duckdb() ) {
				return `${ this.sql_ident( this.duckdb_import_db_name() ) }.${ this.sql_ident( fts_schema_name ) }.match_bm25`
			}
			return `${ this.sql_ident( fts_schema_name ) }.match_bm25`
		}

		duckdb_extension_repository() {
			return `${ $mol_dom_context.location.origin }/shm/ba/duckdb/extension`
		}

		index_name( name: string ) {
			return this.resource_name( name )
		}

		tag_present( tag: string ) {
			return `NULLIF( TRIM( CAST( ${ this.sql_ident( tag ) } AS VARCHAR ) ), '' ) IS NOT NULL`
		}

		tag_missing( tag: string ) {
			return `NULLIF( TRIM( CAST( ${ this.sql_ident( tag ) } AS VARCHAR ) ), '' ) IS NULL`
		}

		metric_names() {
			return [
				'Аудитория',
				'Аудитория СМИ',
				'Цитируемость СМИ',
				'Просмотров',
				'Комментариев',
				'Репостов',
				'Лайков',
				'Вовлеченность',
			]
		}

		metric_value( name: string ) {
			return `COALESCE( TRY_CAST( NULLIF( CAST( ${ this.sql_ident( name ) } AS VARCHAR ), '' ) AS BIGINT ), 0 )`
		}

		metric_alias( name: string ) {
			return `_${ name }`
		}

		metric_name_from_label( label: string ) {
			const aliases: Record< string, string > = {
				'Просмотры': 'Просмотров',
				'Комментарии': 'Комментариев',
				'Репосты': 'Репостов',
				'Лайки': 'Лайков',
			}
			return aliases[ label ] ?? label
		}

		metric_source_expression( table_name: string, conn: $shm_ba_data_connection, name: string ) {
			const alias = this.metric_alias( name )
			if( this.has_column( table_name, conn, alias ) ) return `source.${ this.sql_ident( alias ) }`
			if( this.has_column( table_name, conn, name ) ) {
				return `COALESCE( TRY_CAST( NULLIF( CAST( source.${ this.sql_ident( name ) } AS VARCHAR ), '' ) AS BIGINT ), 0 )`
			}
			return `0`
		}

		table_head( table_name: string, conn: $shm_ba_data_connection ) {
			const table = $mol_wire_sync( conn ).query( `SELECT * FROM ${ table_name } LIMIT 0;` )
			return table.schema.fields.map( ( field: any )=> field.name as string )
		}

		has_column( table_name: string, conn: $shm_ba_data_connection, name: string ) {
			return this.table_head( table_name, conn ).includes( name )
		}

		has_head_column( head: readonly string[], name: string ) {
			return head.includes( name )
		}

		source_ident( name: string ) {
			return `source.${ this.sql_ident( name ) }`
		}

		author_value() {
			return `"_Автор"`
		}

		filter_all_off_key() {
			return '__all__'
		}

		filter_entries( filter: $shm_ba_data_filter ) {
			return Object.entries( filter ).filter( ([ name ])=> name !== this.filter_all_off_key() )
		}

		filter_selected( filter: $shm_ba_data_filter ) {
			return this.filter_entries( filter ).filter( ([ , value ])=> value === true ).map( ([ name ])=> name )
		}

		filter_excluded( filter: $shm_ba_data_filter ) {
			return this.filter_entries( filter ).filter( ([ , value ])=> value === false || value === 'exclude' ).map( ([ name ])=> name )
		}

		filter_condition( expression: string, filter: $shm_ba_data_filter ) {
			const selected = this.filter_selected( filter )
			const excluded = this.filter_excluded( filter )

			if( selected.length ) {
				return `AND ${ expression } IN ( ${ selected.map( value => this.sql_text( value ) ).join( ', ' ) } )`
			}

			if( filter[ this.filter_all_off_key() ] === false ) return 'AND FALSE'

			if( excluded.length ) {
				return `AND ${ expression } NOT IN ( ${ excluded.map( value => this.sql_text( value ) ).join( ', ' ) } )`
			}

			return ''
		}

		@ $mol_mem
		file_name() {
			const file = this.file()
			const uri = this.file_uri()
			if( !file && !uri ) throw new Error( 'Set BA file or BA file URI' )

			return file?.name || uri.split( '?' )[0].split('/').filter(Boolean).pop() || 'ba.csv'
		}

		file_uri_fetch( uri: string ) {
			const uri_fetch = uri.startsWith( 'http://' ) || uri.startsWith( 'https://' ) || uri.startsWith( '/' )
				? uri
				: `/${ uri }`

			const token = this.file_token()
			if( !token || !uri_fetch.includes( '/api/files/' ) || uri_fetch.includes( 'token=' ) ) return uri_fetch

			return `${ uri_fetch }${ uri_fetch.includes( '?' ) ? '&' : '?' }token=${ encodeURIComponent( token ) }`
		}

		@ $mol_mem_key
		file_load_state( uri: string, next?: $shm_ba_data_load_state ) {
			return this.file_loader( uri ).state( next )
		}

		file_load_megabytes( bytes: number ) {
			return `${ ( bytes / 1_000_000 ).toLocaleString( 'ru-RU', {
				minimumFractionDigits: 1,
				maximumFractionDigits: 1,
			} ) } МБ`
		}

		file_load_title() {
			if( this.file() ) return 'Подготовка отчёта'

			const state = this.file_load_state( this.file_uri() )
			if( state.stage === 'cache' ) return 'Проверка локальной копии'
			if( state.stage === 'save' ) return 'Сохранение данных на устройство'
			if( state.stage === 'prepare' ) return 'Подготовка отчёта'
			if( !state.loaded ) return 'Идёт загрузка данных'

			const loaded = this.file_load_megabytes( state.loaded )
			if( !state.total ) return `Идёт загрузка данных ${ loaded }`

			const total = this.file_load_megabytes( state.total )
			const percent = Math.min( 100, Math.round( state.loaded / state.total * 100 ) )
			return `Идёт загрузка данных ${ loaded } из ${ total } — ${ percent }%`
		}

		@ $mol_mem_key
		file_buffer_by_file( file: File ) {
			return $mol_wire_sync( file ).arrayBuffer()
		}

		@ $mol_mem_key
		file_buffer_by_uri( uri: string ) {
			const loader = this.file_loader( uri )
			const local = this.local_file_buffer()
			if( local ) {
				loader.state_set({ stage: 'prepare', loaded: local.byteLength, total: local.byteLength })
				return local
			}

			const buffer = loader.buffer()
			loader.state_set({ stage: 'save', loaded: buffer.byteLength, total: buffer.byteLength })
			this.local_file_store_buffer( this.local_file_key(), buffer )
			loader.state_set({ stage: 'prepare', loaded: buffer.byteLength, total: buffer.byteLength })
			return buffer
		}

		@ $mol_mem_key
		file_loader( uri: string ) {
			const loader = new this.$.$shm_ba_data_loader()
			loader.uri = ()=> this.file_uri_fetch( uri )
			return loader
		}

		local_file_buffer() {
			return $mol_wire_sync( this ).local_file_buffer_async()
		}

		async local_file_buffer_async() {
			const root = await navigator.storage.getDirectory()
			const key = this.local_file_key()
			try {
				const handle = await root.getFileHandle( key )
				const file = await handle.getFile()
				const buffer = await file.arrayBuffer()
				if( this.file_buffer_valid( buffer ) ) return buffer
				await root.removeEntry( key )
				this.local_file_store_changed()
				return null
			} catch( error ) {
				return null
			}
		}

		@ $mol_mem_key
		local_file_store_buffer( key: string, buffer: ArrayBuffer ) {
			if( !this.file_buffer_valid( buffer ) ) throw new Error( `Downloaded file is not a valid ${ this.file_extension() } file` )
			const ready = $mol_wire_sync( this ).local_file_store_buffer_async( key, buffer )
			if( $mol_promise_like( ready ) ) throw ready
			return key
		}

		async local_file_store_buffer_async( key: string, buffer: ArrayBuffer ) {
			const root = await navigator.storage.getDirectory()
			const handle = await root.getFileHandle( key, { create: true } )
			const writable = await handle.createWritable()
			await writable.write( buffer )
			await writable.close()
			this.local_file_store_changed()
		}

		local_file_store_changed() {
			return this.$.$shm_ba_file_store.changed( this.local_file_prefix() )
		}

		@ $mol_mem
		file_buffer() {
			const file = this.file()
			const uri = this.file_uri()
			if( !file && !uri ) throw new Error( 'Set BA file or BA file URI' )

			if( file ) return this.file_buffer_by_file( file )

			return this.file_buffer_by_uri( uri )
		}

		@ $mol_mem
		file_bytes() {
			return new Uint8Array( this.file_buffer() ).slice()
		}

		csv_skip_rows() {
			const buffer = this.file_buffer()
			const bytes = new Uint8Array( buffer, 0, Math.min( buffer.byteLength, 16 * 1024 ) )
			const text = this.csv_decode( bytes )
			const lines = text.split( /\r?\n/ ).slice( 0, 20 )
			const index = lines.findIndex( line => line.split( ';' ).map( part => part.trim().replace( /^\uFEFF/, '' ) ).includes( 'Дата' ) )
			return index >= 0 ? index : 0
		}

		csv_decode( bytes: Uint8Array ) {
			const utf8 = new TextDecoder( 'utf-8' ).decode( bytes )
			if( utf8.includes( 'Дата' ) ) return utf8
			return new TextDecoder( 'windows-1251' ).decode( bytes )
		}

		@ $mol_mem_key
		connection( id: string ) {
			const db = $shm_duckdb.db()
			return $mol_wire_sync( db ).connect()
		}

		@ $mol_mem
		data_connection() {
			return this.connection( 'data' )
		}

		source_read_sql( filename: string ) {
			const ext = this.file_extension()
			if( ext === 'parquet' ) return `read_parquet( ${ this.sql_text( filename ) } )`

			return `read_csv(
				${ this.sql_text( filename ) },
				delim = ';',
				header = true,
				skip = ${ this.csv_skip_rows() }
			)`
		}

		load_parquet_extension( conn: $shm_ba_data_connection ) {
			$mol_wire_sync( conn ).query( `SET custom_extension_repository = ${ this.sql_text( this.duckdb_extension_repository() ) };` )
			$mol_wire_sync( conn ).query( `INSTALL parquet;` )
			$mol_wire_sync( conn ).query( `LOAD parquet;` )
		}

		duckdb_import_table_name( conn: $shm_ba_data_connection ) {
			const import_db_name = this.duckdb_import_db_name()
			const table = $mol_wire_sync( conn ).query( `
				SELECT table_name
				FROM information_schema.tables
				WHERE table_catalog = ${ this.sql_text( import_db_name ) }
					AND table_schema = 'main'
				ORDER BY CASE WHEN table_name = 'ba_messages' THEN 0 ELSE 1 END, table_name
				LIMIT 1;
			` )
			const data = $shm_duckdb.get_head_and_rows_from_vectors( table )
			return String( data.rows[0]?.[0] ?? 'ba_messages' )
		}

		duckdb_import_table_ref( conn: $shm_ba_data_connection ) {
			return `${ this.sql_ident( this.duckdb_import_db_name() ) }.main.${ this.sql_ident( this.duckdb_import_table_name( conn ) ) }`
		}

		table_is_normalized( table_name: string, conn: $shm_ba_data_connection ) {
			const head = this.table_head( table_name, conn )
			return [ '_ID', '_Дата', '_Автор' ].every( name => head.includes( name ) )
		}

		attach_duckdb_file( filename: string, conn: $shm_ba_data_connection ) {
			const import_db_name = this.duckdb_import_db_name()
			$mol_wire_sync( conn ).query( `ATTACH OR REPLACE ${ this.sql_text( filename ) } AS ${ this.sql_ident( import_db_name ) } (READ_ONLY);` )
			return this.duckdb_import_table_ref( conn )
		}

		load_raw_table( table_name: string, filename: string, conn: $shm_ba_data_connection ) {
			const raw_table_name = this.raw_table_name()
			if( this.file_extension() === 'parquet' ) this.load_parquet_extension( conn )

			$mol_wire_sync( conn ).query( `
				CREATE OR REPLACE TABLE ${ raw_table_name } AS
				SELECT * FROM ${ this.source_read_sql( filename ) };
			` )
		}

		normalize_messages_table( table_name: string, conn: $shm_ba_data_connection ) {
			const raw_table_name = this.raw_table_name()
			const head = this.table_head( raw_table_name, conn )
			const raw_columns = head.filter( ( name: string )=> !name.startsWith( '_' ) )
			const raw_select = raw_columns.length
				? raw_columns.map( ( name: string )=> `source.${ this.sql_ident( name ) }` ).join( ',\n\t\t\t\t\t' )
				: 'source.*'
			const date_variants = [
				this.has_head_column( head, '_Дата' ) ? `TRY_CAST( ${ this.source_ident( '_Дата' ) } AS TIMESTAMP )` : '',
				this.has_head_column( head, 'Дата' ) ? `try_strptime( CAST( ${ this.source_ident( 'Дата' ) } AS VARCHAR ), '%d.%m.%Y %H:%M' )` : '',
				this.has_head_column( head, 'Дата' ) ? `TRY_CAST( ${ this.source_ident( 'Дата' ) } AS TIMESTAMP )` : '',
			].filter( Boolean )
			const date_value = date_variants.length
				? `COALESCE( ${ date_variants.join( ', ' ) } )`
				: `TIMESTAMP '0001-01-01'`
			const author_variants = [
				this.has_head_column( head, 'Автор' ) ? `NULLIF( TRIM( CAST( ${ this.source_ident( 'Автор' ) } AS VARCHAR ) ), '' )` : '',
				this.has_head_column( head, '_Автор' ) ? `NULLIF( TRIM( CAST( ${ this.source_ident( '_Автор' ) } AS VARCHAR ) ), '' )` : '',
			].filter( Boolean )
			const author_value = author_variants.length
				? `COALESCE( ${ author_variants.join( ', ' ) }, 'Без автора' )`
				: `'Без автора'`
			const metrics = this.metric_names().map( name => {
				const alias = this.metric_alias( name )
				const value = this.has_head_column( head, name )
					? `COALESCE( TRY_CAST( NULLIF( CAST( ${ this.source_ident( name ) } AS VARCHAR ), '' ) AS BIGINT ), 0 )`
					: this.has_head_column( head, alias )
						? `COALESCE( TRY_CAST( NULLIF( CAST( ${ this.source_ident( alias ) } AS VARCHAR ), '' ) AS BIGINT ), 0 )`
						: '0'
				return `${ value } AS ${ this.sql_ident( alias ) }`
			} ).join( ',\n\t\t\t\t\t' )

			$mol_wire_sync( conn ).query( `
				CREATE OR REPLACE TABLE ${ table_name } AS
				SELECT
					row_number() OVER () AS "_ID",
					${ raw_select },
					${ date_value } AS "_Дата",
					${ author_value } AS "_Автор",
					${ metrics }
				FROM ${ raw_table_name } source;
			` )
		}

		export_limit_sql( limit: number ) {
			const safe = Math.max( 0, Math.floor( Number( limit ) || 0 ) )
			return safe ? `LIMIT ${ safe }` : ''
		}

		export_file_stem() {
			return this.file_name().split( '?' )[0].replace( /\.[^.\/\\]+$/, '' ) || 'ba'
		}

		export_count( limit: number ) {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const table = $mol_wire_sync( conn ).query( `
				SELECT COUNT(*) AS "count"
				FROM (
					SELECT "_ID"
					FROM ${ table_name }
					ORDER BY "_ID"
					${ this.export_limit_sql( limit ) }
				);
			` )
			return Number( table.getChild( 'count' )?.get( 0 ) ?? 0 )
		}

		export_filtered_count() {
			const table_name = this.tables_and_indexes()
			const filtered_table_name = this.filter_table()
			const conn = this.data_connection()
			const table = $mol_wire_sync( conn ).query( `
				SELECT COUNT(*) AS "count"
				FROM ${ table_name } source
				JOIN ${ filtered_table_name } filtered USING( "_ID" );
			` )
			return Number( table.getChild( 'count' )?.get( 0 ) ?? 0 )
		}

		export_filtered_file_name() {
			return `${ this.export_filtered_count() }.csv`
		}

		export_file_name( format: $shm_ba_data_export_format, limit = 0 ) {
			const ext = format === 'duckdb' ? 'duckdb' : format
			return `${ this.export_count( limit ) }.${ ext }`
			// return `${ this.export_file_stem() }_${ this.export_count( limit ) }.${ ext }`
		}

		export_file_path( format: $shm_ba_data_export_format, limit: number ) {
			const ext = format === 'duckdb' ? 'duckdb' : format
			return `${ this.resource_name( 'ba_export' ) }_${ this.export_count( limit ) }.${ ext }`
		}

		export_work_path( format: $shm_ba_data_export_format, limit: number ) {
			const ext = format === 'duckdb' ? 'duckdb' : format
			return `${ this.resource_name( 'ba_export_work' ) }_${ this.export_count( limit ) }.${ ext }`
		}

		export_mime( format: $shm_ba_data_export_format ) {
			if( format === 'csv' ) return 'text/csv;charset=utf-8'
			if( format === 'parquet' ) return 'application/vnd.apache.parquet'
			return 'application/octet-stream'
		}

		duckdb_export_uri() {
			return $mol_state_arg.value( 'ba_duckdb_export' ) || 'http://127.0.0.1:9081/duckdb'
		}

		csv_export_uri() {
			return $mol_state_arg.value( 'ba_csv_export' ) || 'http://127.0.0.1:9081/csv'
		}

		@ $mol_mem_key
		export_csv_blob( parquet_key: string ) {
			const parquet = this.export_blob( parquet_key )
			const blob = $mol_fetch.blob( this.csv_export_uri(), {
				method: 'POST',
				headers: {
					'content-type': this.export_mime( 'parquet' ),
				},
				body: parquet,
			} )
			return new Blob([ blob ], { type: this.export_mime( 'csv' ) } )
		}

		@ $mol_mem_key
		export_duckdb_blob( parquet_key: string ) {
			const parquet = this.export_blob( parquet_key )
			const blob = $mol_fetch.blob( this.duckdb_export_uri(), {
				method: 'POST',
				headers: {
					'content-type': this.export_mime( 'parquet' ),
				},
				body: parquet,
			} )
			return new Blob([ blob ], { type: this.export_mime( 'duckdb' ) } )
		}

		source_table_name( filename: string, conn: $shm_ba_data_connection ) {
			if( this.file_is_duckdb() ) {
				const source_table_name = this.attach_duckdb_file( filename, conn )
				if( this.table_is_normalized( source_table_name, conn ) ) return source_table_name

				$mol_wire_sync( conn ).query( `
					CREATE OR REPLACE TABLE ${ this.raw_table_name() } AS
					SELECT * FROM ${ source_table_name };
				` )
			} else {
				this.load_raw_table( this.messages_table_name(), filename, conn )
				if( this.table_is_normalized( this.raw_table_name(), conn ) ) {
					$mol_wire_sync( conn ).query( `
						CREATE OR REPLACE TABLE ${ this.messages_table_name() } AS
						SELECT * FROM ${ this.raw_table_name() };
					` )
					return this.messages_table_name()
				}
			}

			this.normalize_messages_table( this.messages_table_name(), conn )
			return this.messages_table_name()
		}

		opfs_root() {
			const storage = $mol_dom_context.navigator?.storage
			if( !storage?.getDirectory ) throw new Error( 'OPFS is not supported in this browser' )
			return $mol_wire_sync( storage ).getDirectory()
		}

		opfs_remove_file( path: string ) {
			const root = this.opfs_root()
			return $mol_error_fence(
				()=> $mol_wire_sync( root ).removeEntry( path ),
				()=> null as any,
			)
		}

		opfs_file_blob( path: string ) {
			const root = this.opfs_root()
			const handle = $mol_wire_sync( root ).getFileHandle( path )
			const file = $mol_wire_sync( handle ).getFile()
			const buffer = $mol_wire_sync( file ).arrayBuffer()
			return new Blob([ buffer ], { type: this.export_mime( 'duckdb' ) } )
		}

		@ $mol_mem_key
		export_blob( key: string ) {
			const [ format, limit_text ] = key.split( ':' )
			const limit = Number( limit_text || 0 )
			const typed_format = format as $shm_ba_data_export_format
			const output = typed_format === 'duckdb'
				? this.export_work_path( typed_format, limit )
				: this.export_file_path( typed_format, limit )
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const db = $shm_duckdb.db()

			if( typed_format === 'duckdb' ) {
				db.config.opfs = { fileHandling: 'auto' }
				$mol_error_fence(
					()=> $mol_wire_sync( conn ).query( `DETACH ba_export;` ),
					()=> null as any,
				)
				this.opfs_remove_file( output )
				this.opfs_remove_file( `${ output }.wal` )
			}

			if( typed_format === 'duckdb' ) {
				$mol_error_fence(
					()=> $mol_wire_sync( db ).dropFile( output ),
					()=> {},
				)
			}
			if( typed_format === 'csv' ) {
				$mol_wire_sync( conn ).query( `
					COPY (
						SELECT *
						FROM ${ table_name }
						ORDER BY "_ID"
						${ this.export_limit_sql( limit ) }
					) TO ${ this.sql_text( output ) } (HEADER, DELIMITER ';');
				` )
			} else if( typed_format === 'parquet' ) {
				$mol_wire_sync( conn ).query( `
					COPY (
						SELECT *
						FROM ${ table_name }
						ORDER BY "_ID"
						${ this.export_limit_sql( limit ) }
					) TO ${ this.sql_text( output ) } (FORMAT PARQUET);
				` )
			} else {
				$mol_wire_sync( conn ).query( `ATTACH OR REPLACE ${ this.sql_text( `opfs://${ output }` ) } AS ba_export;` )
				$mol_wire_sync( conn ).query( `
					CREATE OR REPLACE TABLE ba_export.ba_messages AS
					SELECT *
					FROM ${ table_name }
					ORDER BY "_ID"
					${ this.export_limit_sql( limit ) };
				` )
				$mol_wire_sync( conn ).query( `FORCE CHECKPOINT ba_export;` )
				$mol_wire_sync( conn ).query( `DETACH ba_export;` )
			}

			if( typed_format === 'duckdb' ) {
				$mol_wire_sync( db ).flushFiles()
				const blob = this.opfs_file_blob( output )
				this.opfs_remove_file( output )
				this.opfs_remove_file( `${ output }.wal` )
				return blob
			}

			const buffer = $mol_wire_sync( db ).copyFileToBuffer( output )
			const bytes = new Uint8Array( buffer.length )
			bytes.set( buffer )
			return new Blob([ bytes.buffer ], { type: this.export_mime( typed_format ) } )
		}

		@ $mol_mem_key
		export_filtered_csv_blob( key: string ) {
			const output = `${ this.resource_name( 'ba_export_filtered' ) }_${ this.export_filtered_count() }_${ key }.csv`
			const table_name = this.tables_and_indexes()
			const filtered_table_name = this.filter_table()
			const conn = this.data_connection()
			const db = $shm_duckdb.db()
			const columns = this.table_head( table_name, conn )
				.filter( name => !name.startsWith( '_' ) )
				.map( name => `source.${ this.sql_ident( name ) }` )
				.join( ',\n\t\t\t\t\t\t' )
			$mol_wire_sync( conn ).query( `
				COPY (
					SELECT
						${ columns || 'source.*' }
					FROM ${ table_name } source
					JOIN ${ filtered_table_name } filtered USING( "_ID" )
					ORDER BY source."_ID"
				) TO ${ this.sql_text( output ) } (HEADER, DELIMITER ';');
			` )
			const buffer = $mol_wire_sync( db ).copyFileToBuffer( output )
			const bytes = new Uint8Array( buffer.length )
			bytes.set( buffer )
			return new Blob([ '\uFEFF', bytes.buffer ], { type: this.export_mime( 'csv' ) } )
		}

		@ $mol_mem
		file_ready() {
			const filename = this.file_db_name()
			const buffer = this.file_buffer()

			return $mol_wire_sync( this ).file_register_async( filename, buffer, this.file_extension(), this.csv_skip_rows() )
		}

		async file_register_async( filename: string, buffer: ArrayBuffer, extension: string, csv_skip_rows: number ) {
			const db = await $shm_duckdb.db_async()
			const prev_url = $shm_duckdb._file_urls.get( filename )

			try {
				await db.dropFile( filename )
			} catch( error ) {
				// DuckDB has no "drop if exists" for registered files.
			}
			if( prev_url ) URL.revokeObjectURL( prev_url )

			if( extension === 'csv' ) {
				await db.registerFileText( filename, this.csv_decode( new Uint8Array( buffer ) ) )
			} else if( extension === 'duckdb' || extension === 'db' ) {
				await db.registerFileBuffer( filename, new Uint8Array( buffer ).slice() )
			} else {
				const url = URL.createObjectURL( new Blob([ buffer ]) )
				$shm_duckdb._file_urls.set( filename, url )
				const DuckDBDataProtocolBrowserFilereader = 2
				await db.registerFileURL( filename, url, DuckDBDataProtocolBrowserFilereader, false )
			}
			if( extension === 'csv' ) {
				const conn = await db.connect()
				try {
					await conn.query( `
						SELECT *
						FROM read_csv(
							${ this.sql_text( filename ) },
							delim = ';',
							header = true,
							skip = ${ csv_skip_rows }
						)
						LIMIT 1;
					` )
				} finally {
					await conn.close()
				}
			}
			return filename
		}

		@ $mol_mem
		tables_and_indexes_ready() {
			const filename = this.file_db_name()
			const ready = $mol_wire_sync( this ).file_register_async( filename, this.file_buffer(), this.file_extension(), this.csv_skip_rows() )
			if( $mol_promise_like( ready ) ) throw ready
			const tags_table_name = this.tags_table_name()
			const conn = this.data_connection()
			this.fts_index_built( false )
			this.fts_indexing( false )

			const table_name = this.source_table_name( filename, conn )
			if( !this.file_is_duckdb() || table_name === this.messages_table_name() ) {
				$mol_error_fence(
					()=> {
						$mol_wire_sync( conn ).query( `CREATE INDEX ${ this.index_name( 'ba_messages_date_idx' ) } ON ${ table_name }( "_Дата" );` )
						$mol_wire_sync( conn ).query( `CREATE INDEX ${ this.index_name( 'ba_messages_author_idx' ) } ON ${ table_name }( "_Автор" );` )
						$mol_wire_sync( conn ).query( `CREATE INDEX ${ this.index_name( 'ba_messages_source_idx' ) } ON ${ table_name }( "Источник" );` )
					},
					()=> {},
				)
			}

			if( !this.duckdb_import_has_table( 'ba_message_tags' ) ) {
				const tag_names = this.tag_names( table_name, conn )
				$mol_wire_sync( conn ).query( `
					CREATE OR REPLACE TABLE ${ tags_table_name } AS
					${
						tag_names.length
							? tag_names.map( tag => `
								SELECT "_ID", ${ this.sql_text( tag ) } AS "Тег"
								FROM ${ table_name }
								WHERE ${ this.tag_present( tag ) }
							` ).join( '\nUNION ALL\n' )
							: `SELECT "_ID", '' AS "Тег" FROM ${ table_name } WHERE FALSE`
					};
				` )
				$mol_error_fence(
					()=> {
						$mol_wire_sync( conn ).query( `CREATE INDEX ${ this.index_name( 'ba_message_tags_id_idx' ) } ON ${ tags_table_name }( "_ID" );` )
						$mol_wire_sync( conn ).query( `CREATE INDEX ${ this.index_name( 'ba_message_tags_tag_idx' ) } ON ${ tags_table_name }( "Тег" );` )
					},
					()=> {},
				)
			}

			return table_name
		}

		@ $mol_mem
		tables_and_indexes() {
			return this.tables_and_indexes_ready()
		}

		visible_tags() {
			return null as readonly string[] | null
		}

		excluded_tags() {
			return [] as readonly string[]
		}

		@ $mol_mem_key
		tag_names( table_name: string, conn: $shm_ba_data_connection ): string[] {
			const head = this.table_head( table_name, conn )
			const address = head.indexOf( 'Адрес' )
			const tag_start = address === -1 ? head.indexOf( 'Telemetr' ) : address + 1
			const tags = tag_start === -1 ? [] : head.slice( tag_start ).filter( ( name: string )=> !name.startsWith( '_' ) )
			const visible = this.visible_tags()
			const excluded = new Set( this.excluded_tags() )
			return ( visible === null ? tags : tags.filter( tag => visible.includes( tag ) ) )
				.filter( tag => !excluded.has( tag ) )
		}

		load_fts_extension( conn: $shm_ba_data_connection ) {
			$mol_wire_sync( conn ).query( `SET custom_extension_repository = ${ this.sql_text( this.duckdb_extension_repository() ) };` )
			$mol_wire_sync( conn ).query( `INSTALL fts;` )
			$mol_wire_sync( conn ).query( `LOAD fts;` )
		}

		duckdb_fts_index_saved( conn: $shm_ba_data_connection ) {
			const import_db_name = this.duckdb_import_db_name()
			const fts_schema_name = this.fts_schema_name()
			const table = $mol_wire_sync( conn ).query( `
				SELECT table_name
				FROM information_schema.tables
				WHERE table_catalog = ${ this.sql_text( import_db_name ) }
					AND table_schema = ${ this.sql_text( fts_schema_name ) };
			` )
			const names = new Set( $shm_duckdb.get_head_and_rows_from_vectors( table ).rows.map( row => String( row[0] ) ) )
			return [ 'dict', 'docs', 'fields', 'stats', 'terms' ].every( name => names.has( name ) )
		}

		duckdb_fts_index_ready( conn: $shm_ba_data_connection ) {
			if( !this.duckdb_fts_index_saved( conn ) ) return false

			const import_db_name = this.duckdb_import_db_name()
			const fts_schema_name = this.fts_schema_name()
			$mol_error_fence(
				()=> $mol_wire_sync( conn ).query( `DROP SCHEMA IF EXISTS ${ this.sql_ident( fts_schema_name ) } CASCADE;` ),
				error => error,
			)
			$mol_wire_sync( conn ).query( `CREATE SCHEMA ${ this.sql_ident( fts_schema_name ) };` )
			for( const table of [ 'dict', 'docs', 'fields', 'stats', 'stopwords', 'terms' ] ) {
				$mol_wire_sync( conn ).query( `
					CREATE VIEW ${ this.sql_ident( fts_schema_name ) }.${ this.sql_ident( table ) } AS
					SELECT * FROM ${ this.sql_ident( import_db_name ) }.${ this.sql_ident( fts_schema_name ) }.${ this.sql_ident( table ) };
				` )
			}
			$mol_wire_sync( conn ).query( `
				CREATE MACRO ${ this.sql_ident( fts_schema_name ) }.tokenize( s ) AS
				string_split_regex(
					regexp_replace( lower( CAST( s AS VARCHAR ) ), '[^А-Яа-яЁёA-Za-z0-9]+', ' ', 'g' ),
					'\\\\s+'
				);
			` )
			return true
		}

		period_condition( alias = '' ) {
			const prefix = alias ? `${ alias }.` : ''
			const period = this.period_fit( this.period() )
			return `
				${ prefix }"_Дата" >= ${ this.period_start_sql( period.from ) }
				AND ${ prefix }"_Дата" < ${ this.period_finish_sql( period.to ) }
			`
		}

		date_has_time( date: string ) {
			return /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}/.test( date )
		}

		date_sql_text( date: string ) {
			return this.sql_text( date.replace( 'T', ' ' ) )
		}

		period_start_sql( date: string ) {
			return this.date_has_time( date )
				? `TIMESTAMP ${ this.date_sql_text( date ) }`
				: `DATE ${ this.sql_text( date ) }`
		}

		period_finish_sql( date: string ) {
			return this.date_has_time( date )
				? `TIMESTAMP ${ this.date_sql_text( date ) } + INTERVAL 1 MINUTE`
				: `DATE ${ this.sql_text( date ) } + INTERVAL 1 DAY`
		}

		// @ $shm_hitalama_process_mem
		@ $mol_mem
		fts_index_ready() {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			if( this.fts_index_built() ) return true

			const fields = [ 'Заголовок', 'Текст' ].filter( name => this.has_column( table_name, conn, name ) )
			if( !fields.length ) return false

			return $mol_error_fence(
				()=> {
					this.fts_indexing( true )
					this.load_fts_extension( conn )
					if( this.file_is_duckdb() ) {
						const ready = this.duckdb_fts_index_ready( conn )
						this.fts_index_built( ready )
						this.fts_indexing( false )
						return ready
					}
					$mol_wire_sync( conn ).query( `
						PRAGMA create_fts_index(
							${ this.sql_text( table_name ) },
							'_ID',
							${ fields.map( field => this.sql_text( field ) ).join( ',\n\t\t\t\t\t\t\t' ) },
							stemmer = 'russian',
							stopwords = 'none',
							ignore = '[^А-Яа-яЁёA-Za-z0-9]+',
							strip_accents = 0,
							lower = 1,
							overwrite = 1
						);
					` )
					this.fts_index_built( true )
					this.fts_indexing( false )
					return true
				},
				()=> {
					this.fts_indexing( false )
					return false
				},
			)
		}

		@ $mol_mem
		fts_index_built( next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem
		fts_indexing( next?: boolean ) {
			return next ?? false
		}

		search_condition( alias = 'source' ) {
			const query = this.search_query().trim()
			if( !query ) return ''

			const like = this.sql_like_pattern( query )
			const like_operator = this.search_case_sensitive() ? 'LIKE' : 'ILIKE'
			const like_condition = `
				COALESCE( CAST( ${ alias }."Заголовок" AS VARCHAR ), '' ) ${ like_operator } ${ like } ESCAPE '$'
				OR COALESCE( CAST( ${ alias }."Текст" AS VARCHAR ), '' ) ${ like_operator } ${ like } ESCAPE '$'
			`
			const conditions = [] as string[]

			if( this.search_mode() === 'fts' && this.fts_index_ready() ) {
				conditions.push( `
					${ this.fts_match_ref() }(
						${ alias }."_ID",
						${ this.sql_text( query.toLowerCase() ) }
					) IS NOT NULL
				` )
			}

			if( this.search_mode() === 'substring' ) conditions.push( like_condition )
			if( !conditions.length ) conditions.push( 'FALSE' )

			return `
				AND ( ${ conditions.join( ' OR ' ) } )
			`
		}

		date_text( date: unknown ) {
			if( date instanceof Date ) {
				const year = date.getFullYear()
				const month = String( date.getMonth() + 1 ).padStart( 2, '0' )
				const day = String( date.getDate() ).padStart( 2, '0' )
				return `${ year }-${ month }-${ day }`
			}
			const text = String( date ?? '' )
			const iso = text.match( /^(\d{4})-(\d{2})-(\d{2})/ )
			if( iso ) return `${ iso[1] }-${ iso[2] }-${ iso[3] }`
			const ru = text.match( /^(\d{2})\.(\d{2})\.(\d{4})/ )
			if( ru ) return `${ ru[3] }-${ ru[2] }-${ ru[1] }`
			return text.slice( 0, 10 )
		}

		date_fit( date: string ) {
			const time = date.match( /^\d{4}-\d{2}-\d{2}[ T](\d{2}):(\d{2})/ )
			const match = date.slice( 0, 10 ).match( /^(\d{4})-(\d{2})-(\d{2})$/ )
			if( !match ) return date

			const year = Number( match[1] )
			const month = Math.min( 12, Math.max( 1, Number( match[2] ) ) )
			const day_max = new Date( year, month, 0 ).getDate()
			const day = Math.min( day_max, Math.max( 1, Number( match[3] ) ) )

			const result = [
				String( year ).padStart( 4, '0' ),
				String( month ).padStart( 2, '0' ),
				String( day ).padStart( 2, '0' ),
			].join( '-' )
			return time ? `${ result } ${ time[1] }:${ time[2] }` : result
		}

		period_fit( period: $shm_ba_data_period ) {
			let from = this.date_fit( period.from )
			let to = this.date_fit( period.to )
			if( from && to && from > to ) {
				if( period.from !== from ) to = from
				else from = to
			}
			return { from, to }
		}

		@ $mol_mem
		period_all(): $shm_ba_data_period {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const table = $mol_wire_sync( conn ).query( `
				SELECT
					CAST( MIN( date_trunc( 'day', "_Дата" ) ) AS DATE ) AS "from",
					CAST( MAX( date_trunc( 'day', "_Дата" ) ) AS DATE ) AS "to"
				FROM ${ table_name };
			` )
			const data = $shm_duckdb.get_head_and_rows_from_vectors( table )
			return {
				from: this.date_text( data.rows[0]?.[0] ) || '0001-01-01',
				to: this.date_text( data.rows[0]?.[1] ) || '2999-12-31',
			}
		}

		@ $mol_mem
		period_table() {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const period_table_name = this.period_table_name()
			$mol_wire_sync( conn ).query( `
				CREATE OR REPLACE TABLE ${ period_table_name } AS
				SELECT source."_ID"
				FROM ${ table_name } source
				WHERE ${ this.period_condition( 'source' ) };
			` )
			$mol_error_fence(
				()=> $mol_wire_sync( conn ).query( `CREATE INDEX ${ this.index_name( 'ba_messages_period_ids_id_idx' ) } ON ${ period_table_name }( "_ID" );` ),
				error => error,
			)
			return period_table_name
		}

		@ $mol_mem
		filter_table() {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const period_table_name = this.period_table()
			const filtered_table_name = this.filtered_table_name()
			let started_at = $shm_ba_data_filter_started_at.get( this )
			if( !started_at ) {
				started_at = {
					date: new Date(),
					time: $mol_dom_context.performance.now(),
				}
				$shm_ba_data_filter_started_at.set( this, started_at )
				console.log( 'Время запуска фильтров:', started_at.date.toISOString() )
			}

			$mol_error_fence(
				()=> {
					$mol_wire_sync( conn ).query( `
						CREATE OR REPLACE TABLE ${ filtered_table_name } AS
						SELECT source."_ID"
						FROM ${ table_name } source
						JOIN ${ period_table_name } period USING( "_ID" )
						WHERE ${ this.filter_conditions_without_period( table_name, conn ) };
					` )
					$mol_error_fence(
						()=> $mol_wire_sync( conn ).query( `CREATE INDEX ${ this.index_name( 'ba_messages_filtered_ids_id_idx' ) } ON ${ filtered_table_name }( "_ID" );` ),
						error => error,
					)
				},
				error => {
					$shm_ba_data_filter_started_at.delete( this )
					return error
				},
			)

			$shm_ba_data_filter_started_at.delete( this )
			console.log( 'Время работы фильтров:', `${ ( $mol_dom_context.performance.now() - started_at.time ).toFixed( 1 ) } мс` )

			return filtered_table_name
		}

		tag_filter_conditions( table_name: string, conn: $shm_ba_data_connection ) {
			const tags_table_name = this.tags_table_ref( table_name, conn )
			const tags = this.tags_filter()
			const tag_names = this.tag_names( table_name, conn )
			const selected_tags = this.filter_selected( tags )
			const excluded_tags = this.filter_excluded( tags )
			const selected_known_tags = selected_tags.filter( tag => tag_names.includes( tag ) )
			const excluded_known_tags = excluded_tags.filter( tag => tag_names.includes( tag ) )
			const tag_conditions = [] as string[]
			const tag_exclude_conditions = [] as string[]

			if( selected_known_tags.length ) {
				tag_conditions.push( `
					EXISTS (
						SELECT 1
						FROM ${ tags_table_name } tag
						WHERE tag."_ID" = source."_ID"
						AND tag."Тег" IN ( ${ selected_known_tags.map( tag => this.sql_text( tag ) ).join( ', ' ) } )
					)
				` )
			}
			if( selected_tags.includes( 'Без тегов' ) && tag_names.length ) {
				tag_conditions.push( `
					NOT EXISTS (
						SELECT 1
						FROM ${ tags_table_name } tag
						WHERE tag."_ID" = source."_ID"
					)
				` )
			}
			if( excluded_known_tags.length ) {
				tag_exclude_conditions.push( `
					NOT EXISTS (
						SELECT 1
						FROM ${ tags_table_name } tag
						WHERE tag."_ID" = source."_ID"
						AND tag."Тег" IN ( ${ excluded_known_tags.map( tag => this.sql_text( tag ) ).join( ', ' ) } )
					)
				` )
			}
			if( excluded_tags.includes( 'Без тегов' ) && tag_names.length ) {
				tag_exclude_conditions.push( `
					EXISTS (
						SELECT 1
						FROM ${ tags_table_name } tag
						WHERE tag."_ID" = source."_ID"
					)
				` )
			}

			const selected = selected_tags.length || tags[ this.filter_all_off_key() ] === false
				? `AND ${ tag_conditions.length ? `( ${ tag_conditions.join( ' OR ' ) } )` : 'FALSE' }`
				: ''
			const excluded = tag_exclude_conditions.length
				? `AND ${ tag_exclude_conditions.join( ' AND ' ) }`
				: ''
			return `${ selected } ${ excluded }`
		}

		filter_conditions(
			table_name: string,
			conn: $shm_ba_data_connection,
		) {
			return `
				${ this.period_condition( 'source' ) }
				${ this.tag_filter_conditions( table_name, conn ) }
				${ this.filter_condition( `source."Источник"`, this.sources_filter() ) }
				${ this.filter_condition( `source.${ this.author_value() }`, this.authors_filter() ) }
				${ this.filter_condition( `source."Тип сообщения"`, this.message_types_filter() ) }
				${ this.filter_condition( `source."Тип источника"`, this.source_types_filter() ) }
				${ this.search_condition( 'source' ) }
			`
		}

		filter_conditions_without_period(
			table_name: string,
			conn: $shm_ba_data_connection,
		) {
			return `
				TRUE
				${ this.tag_filter_conditions( table_name, conn ) }
				${ this.filter_condition( `source."Источник"`, this.sources_filter() ) }
				${ this.filter_condition( `source.${ this.author_value() }`, this.authors_filter() ) }
				${ this.filter_condition( `source."Тип сообщения"`, this.message_types_filter() ) }
				${ this.filter_condition( `source."Тип источника"`, this.source_types_filter() ) }
				${ this.search_condition( 'source' ) }
			`
		}

		facet_filter_sql(
			table_name: string,
			conn: $shm_ba_data_connection,
		) {
			return this.filter_table()
		}

		@ $mol_mem
		query_tables() {
			const messages = this.tables_and_indexes()
			const filtered = this.filter_table()
			return {
				messages,
				source: messages,
				filtered,
				tags: this.tags_table_ref( messages, this.data_connection() ),
			}
		}

		@ $mol_mem_key
		query_sql( sql: string ): $shm_ba_data_table {
			this.query_tables()
			const table = $mol_wire_sync( this.data_connection() ).query( sql )
			return $shm_duckdb.get_head_and_rows_from_vectors( table )
		}

		@ $mol_mem
		query_table(): $shm_ba_data_table {
			const table_name = this.tables_and_indexes()
			const filtered_table_name = this.filter_table()
			const conn = this.data_connection()
			const table = $mol_wire_sync( conn ).query( `
				SELECT
					CAST( date_trunc( 'day', source."_Дата" ) AS DATE ) AS "Дата",
					source."Источник",
					source."Тип источника",
					source."Язык",
					source."Тональность",
					COUNT(*) AS "Сообщений",
					${ this.metric_names().map( name => `SUM( ${ this.metric_source_expression( table_name, conn, name ) } ) AS ${ this.sql_ident( name ) }` ).join( ',\n\t\t\t\t\t' ) }
				FROM ${ table_name } source
				JOIN ${ filtered_table_name } filtered USING( "_ID" )
				GROUP BY 1, 2, 3, 4, 5
				ORDER BY "Дата" DESC, "Сообщений" DESC;
			` )
			return $shm_duckdb.get_head_and_rows_from_vectors( table )
		}

		@ $mol_mem
		query_summary(): $shm_ba_data_table {
			const indicators = this.summary_indicators()
			if( !indicators.length ) return { head: [], rows: [ [] ] }

			const table_name = this.tables_and_indexes()
			const filtered_table_name = this.filter_table()
			const conn = this.data_connection()
			const expressions: Record< string, ()=> string > = {
				'Сообщения': ()=> 'COUNT(*) AS "Всего сообщений"',
				'Авторы': ()=> 'COUNT( DISTINCT source."_Автор" ) AS "Авторы"',
				'Источники': ()=> 'COUNT( DISTINCT source."Источник" ) AS "Источники"',
				'Аудитория': ()=> `COALESCE( (
					SELECT SUM( author."_Аудитория" )
					FROM (
						SELECT source."_Автор", MAX( ${ this.metric_source_expression( table_name, conn, 'Аудитория' ) } ) AS "_Аудитория"
						FROM ${ table_name } source
						JOIN ${ filtered_table_name } filtered USING( "_ID" )
						WHERE ${ this.audience_message_condition( 'source' ) }
						GROUP BY 1
					) author
				), 0 ) AS "Аудитория"`,
				'Просмотры': ()=> `SUM( ${ this.metric_source_expression( table_name, conn, 'Просмотров' ) } ) AS "Просмотры"`,
				'Комментарии': ()=> `SUM( ${ this.metric_source_expression( table_name, conn, 'Комментариев' ) } ) AS "Комментарии"`,
				'Вовлеченность': ()=> `SUM( ${ this.metric_source_expression( table_name, conn, 'Вовлеченность' ) } ) AS "Вовлеченность"`,
				'Лайки': ()=> `SUM( ${ this.metric_source_expression( table_name, conn, 'Лайков' ) } ) AS "Лайки"`,
				'Репосты': ()=> `SUM( ${ this.metric_source_expression( table_name, conn, 'Репостов' ) } ) AS "Репосты"`,
				'Аудитория СМИ': ()=> `CAST( ROUND( AVG( ${ this.metric_source_expression( table_name, conn, 'Аудитория СМИ' ) } ) FILTER( WHERE source."Тип источника" = ${ this.sql_text( 'Онлайн-СМИ' ) } ) ) AS BIGINT ) AS "Средняя аудитория СМИ"`,
				'Цитируемость СМИ': ()=> `CAST( ROUND( AVG( ${ this.metric_source_expression( table_name, conn, 'Цитируемость СМИ' ) } ) FILTER( WHERE source."Тип источника" = ${ this.sql_text( 'Онлайн-СМИ' ) } ) ) AS BIGINT ) AS "Средняя цитируемость СМИ"`,
			}
			const selected_expressions = indicators
				.map( indicator => expressions[ indicator ] )
				.filter( ( expression ): expression is ()=> string => Boolean( expression ) )
			if( !selected_expressions.length ) return { head: [], rows: [ [] ] }
			const table = $mol_wire_sync( conn ).query( `
				SELECT
					${ selected_expressions.map( expression => expression() ).join( ',\n\t\t\t\t\t' ) }
				FROM ${ table_name } source
				JOIN ${ filtered_table_name } filtered USING( "_ID" );
			` )
			return $shm_duckdb.get_head_and_rows_from_vectors( table )
		}

		@ $mol_mem
		query_posts(): $shm_ba_data_table {
			return this.query_posts_ready( null, 0 )
		}

		@ $mol_mem_key
		query_posts_page( page: string ): $shm_ba_data_table {
			const [ limit_raw, offset_raw ] = page.split( ':' ).map( Number )
			const limit = Number.isFinite( limit_raw ) ? Math.max( 0, Math.floor( limit_raw ) ) : 25
			const offset = Number.isFinite( offset_raw ) ? Math.max( 0, Math.floor( offset_raw ) ) : 0
			return this.query_posts_ready( limit, offset )
		}

		@ $mol_mem
		query_posts_count() {
			const filtered_table_name = this.filter_table()
			const conn = this.data_connection()
			const table = $mol_wire_sync( conn ).query( `
				SELECT COUNT(*) AS "Всего"
				FROM ${ filtered_table_name };
			` )
			const data = $shm_duckdb.get_head_and_rows_from_vectors( table )
			return Number( data.rows[0]?.[0] ?? 0 )
		}

		query_posts_limit( limit: number | null, offset: number ) {
			if( limit === null ) return ''
			return `LIMIT ${ limit } OFFSET ${ offset }`
		}

		query_posts_ready( limit: number | null, offset: number ): $shm_ba_data_table {
			const table_name = this.tables_and_indexes()
			const filtered_table_name = this.filter_table()
			const conn = this.data_connection()
			const tags_table_name = this.tags_table_ref( table_name, conn )
			const sort = this.post_sort_expression( table_name, conn )
			const sort_order = this.posts_sort_order() === 'asc' ? 'ASC' : 'DESC'
			const table = $mol_wire_sync( conn ).query( `
				WITH page AS (
					SELECT source."_ID"
					FROM ${ table_name } source
					JOIN ${ filtered_table_name } filtered USING( "_ID" )
					ORDER BY ${ sort } ${ sort_order }, source."_Дата" DESC, source."_ID" DESC
					${ this.query_posts_limit( limit, offset ) }
				), tags AS (
					SELECT tag."_ID", string_agg( tag."Тег", ', ' ORDER BY tag."Тег" ) AS "Теги"
					FROM ${ tags_table_name } tag
					JOIN page USING( "_ID" )
					GROUP BY 1
				)
				SELECT
					source."Дата",
					source."Заголовок",
					source."Текст",
					source."Источник",
					source."Url",
					source."Тип источника",
					source."Тип сообщения",
					source."Автор",
					source."Url автора",
					COALESCE( tags."Теги", '' ) AS "Теги",
					source."Тональность",
					source."Просмотров",
					source."Комментариев",
					source."Репостов",
					source."Лайков",
					source."Вовлеченность",
					source."Аудитория",
					${ this.metric_source_expression( table_name, conn, 'Аудитория СМИ' ) } AS "Аудитория СМИ",
					${ this.metric_source_expression( table_name, conn, 'Цитируемость СМИ' ) } AS "Цитируемость СМИ"
				FROM page
				JOIN ${ table_name } source USING( "_ID" )
				LEFT JOIN tags USING( "_ID" )
				ORDER BY ${ sort } ${ sort_order }, source."_Дата" DESC, source."_ID" DESC
				;
			` )
			return $shm_duckdb.get_head_and_rows_from_vectors( table )
		}

		post_sort_expression( table_name: string, conn: $shm_ba_data_connection ) {
			const name = this.posts_sort()
			if( name === 'Дата' ) return `source."_Дата"`
			const metric_name = this.metric_name_from_label( name )
			if( this.metric_names().includes( metric_name ) ) return this.metric_source_expression( table_name, conn, metric_name )
			if( this.has_column( table_name, conn, name ) ) {
				if( name.toLowerCase().includes( 'дата' ) ) {
					return `COALESCE( TRY_CAST( source.${ this.sql_ident( name ) } AS TIMESTAMP ), TIMESTAMP '0001-01-01' )`
				}
				return `COALESCE( TRY_CAST( NULLIF( CAST( source.${ this.sql_ident( name ) } AS VARCHAR ), '' ) AS DOUBLE ), 0 )`
			}
			return `0`
		}

		@ $mol_mem
		tags(): $shm_ba_data_table {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const tags_table_name = this.tags_table_ref( table_name, conn )
			const period_table_name = this.period_table()
			const facet_filter = this.facet_filter_sql( table_name, conn )
			const tag_names = this.tag_names( table_name, conn )
			if( !tag_names.length ) return { head: [ 'Тег', 'Сообщений', 'Всего' ], rows: [] }

			const table = $mol_wire_sync( conn ).query( `
				SELECT total."Тег", COALESCE( filtered."Сообщений", 0 ) AS "Сообщений", total."Всего"
				FROM (
					SELECT tag."Тег", COUNT(*) AS "Всего"
					FROM ${ tags_table_name } tag
					JOIN ${ period_table_name } period USING( "_ID" )
					GROUP BY 1
					UNION ALL
					SELECT 'Без тегов' AS "Тег", COUNT(*) AS "Всего"
					FROM ${ period_table_name } period
					WHERE NOT EXISTS (
							SELECT 1
							FROM ${ tags_table_name } tag
							WHERE tag."_ID" = period."_ID"
						)
				) AS total
				LEFT JOIN (
					SELECT tag."Тег", COUNT(*) AS "Сообщений"
					FROM ${ tags_table_name } tag
					JOIN ${ facet_filter } filtered USING( "_ID" )
					GROUP BY 1
					UNION ALL
					SELECT 'Без тегов' AS "Тег", COUNT(*) AS "Сообщений"
					FROM ${ facet_filter } filtered
					WHERE NOT EXISTS (
						SELECT 1
						FROM ${ tags_table_name } tag
						WHERE tag."_ID" = filtered."_ID"
					)
				) AS filtered USING( "Тег" )
				ORDER BY "Сообщений" DESC, total."Всего" DESC, total."Тег";
			` )
			return $shm_duckdb.get_head_and_rows_from_vectors( table )
		}

		@ $mol_mem
		sources(): $shm_ba_data_table {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const period_table_name = this.period_table()
			const facet_filter = this.facet_filter_sql( table_name, conn )
			const table = $mol_wire_sync( conn ).query( `
				SELECT
					source."Источник",
					COUNT(*) FILTER ( WHERE filtered."_ID" IS NOT NULL ) AS "Сообщений",
					COUNT(*) AS "Всего"
				FROM ${ table_name } source
				JOIN ${ period_table_name } period USING( "_ID" )
				LEFT JOIN ${ facet_filter } filtered USING( "_ID" )
				GROUP BY 1
				ORDER BY "Сообщений" DESC, "Всего" DESC, source."Источник";
			` )
			return $shm_duckdb.get_head_and_rows_from_vectors( table )
		}

		@ $mol_mem
		source_types(): $shm_ba_data_table {
			return this.field_filter_table( 'Тип источника' )
		}

		@ $mol_mem
		message_types(): $shm_ba_data_table {
			return this.field_filter_table( 'Тип сообщения' )
		}

		field_filter_table( name: string ): $shm_ba_data_table {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const period_table_name = this.period_table()
			const facet_filter = this.facet_filter_sql( table_name, conn )
			const field = this.sql_ident( name )
			const table = $mol_wire_sync( conn ).query( `
				SELECT
					source.${ field } AS ${ field },
					COUNT(*) FILTER ( WHERE filtered."_ID" IS NOT NULL ) AS "Сообщений",
					COUNT(*) AS "Всего"
				FROM ${ table_name } source
				JOIN ${ period_table_name } period USING( "_ID" )
				LEFT JOIN ${ facet_filter } filtered USING( "_ID" )
				GROUP BY 1
				ORDER BY "Сообщений" DESC, "Всего" DESC, source.${ field };
			` )
			return $shm_duckdb.get_head_and_rows_from_vectors( table )
		}

		@ $mol_mem
		authors(): $shm_ba_data_table {
			const table_name = this.tables_and_indexes()
			const conn = this.data_connection()
			const period_table_name = this.period_table()
			const facet_filter = this.facet_filter_sql( table_name, conn )
			const table = $mol_wire_sync( conn ).query( `
				SELECT
					source.${ this.author_value() } AS "Автор",
					COUNT(*) FILTER ( WHERE filtered."_ID" IS NOT NULL ) AS "Сообщений",
					COUNT(*) AS "Всего"
				FROM ${ table_name } source
				JOIN ${ period_table_name } period USING( "_ID" )
				LEFT JOIN ${ facet_filter } filtered USING( "_ID" )
				GROUP BY 1
				ORDER BY "Сообщений" DESC, "Всего" DESC, "Автор";
			` )
			return $shm_duckdb.get_head_and_rows_from_vectors( table )
		}

		chart_timeseries() {
			return this.current_filter_chart_ready()
		}

		// @ $shm_hitalama_process_mem
		@ $mol_mem
		current_filter_chart_ready() {
			const conn = this.data_connection()
			const period = this.period()
			const group = this.chart_group()
			const date_expression = this.chart_date_expression( 'source' )
			const step = group === 'year' ? '1 YEAR' : group === 'halfyear' ? '6 MONTH' : group === 'quarter' ? '3 MONTH' : group === 'month' ? '1 MONTH' : group === 'week' ? '1 WEEK' : group === 'hour' ? '1 HOUR' : group === 'minute5' ? '5 MINUTE' : '1 DAY'
			const start = this.chart_bucket_start( period.from )
			const finish = this.chart_bucket_finish( period.to )
			const label_expression = group === 'quarter'
				? `strftime( bucket."Дата", '%Y' ) || ' Q' || CAST( quarter( bucket."Дата" ) AS VARCHAR )`
				: group === 'halfyear'
					? `strftime( bucket."Дата", '%Y' ) || ' H' || CAST( CASE WHEN month( bucket."Дата" ) > 6 THEN 2 ELSE 1 END AS VARCHAR )`
					: group === 'year'
						? `strftime( bucket."Дата", '%Y' )`
						: group === 'month'
							? `strftime( bucket."Дата", '%m.%Y' )`
							: group === 'week'
								? `CAST( bucket."Дата" AS DATE )`
								: group === 'hour'
									? this.date_day( period.from ) === this.date_day( period.to )
										? `strftime( bucket."Дата", '%H:00' )`
										: `strftime( bucket."Дата", '%d.%m.%Y %H:00' )`
									: group === 'minute5'
										? this.date_day( period.from ) === this.date_day( period.to )
											? `strftime( bucket."Дата", '%H:%M' )`
											: `strftime( bucket."Дата", '%d.%m.%Y %H:%M' )`
										: `strftime( bucket."Дата", '%d.%m.%Y' )`
			const metric_sql = this.chart_metric_sql( date_expression )
			const table = $mol_wire_sync( conn ).query( `
				SELECT
					${ label_expression } AS "Дата",
					CAST( bucket."Дата" AS DATE ) AS "_День",
					strftime( bucket."Дата", '%Y-%m-%d %H:%M:%S' ) AS "_Бакет",
					COALESCE( metric."Значение", 0 ) AS "Значение"
				FROM generate_series( ${ start }, ${ finish }, INTERVAL ${ this.sql_text( step ) } ) AS bucket( "Дата" )
				LEFT JOIN (
					${ metric_sql }
				) metric USING( "Дата" )
				ORDER BY bucket."Дата";
			` )
			const data = $shm_duckdb.get_head_and_rows_from_vectors( table )
			return data.rows.map( ([ label, date, bucket, count ])=> {
				const day = this.date_text( date )
				return [
					group === 'week' ? this.chart_week_label( day ) : String( label ?? '' ),
					Number( count ?? 0 ),
					day,
					String( bucket ?? '' ),
				] as const
			} )
		}

		chart_week_label( date: string ) {
			return [
				this.date_label_ru( date ),
				`- ${ this.date_label_ru( this.date_shift_text( date, day => new Date( day.getFullYear(), day.getMonth(), day.getDate() + 6 ) ) ) }`,
			].join( '\n' )
		}

		date_label_ru( date: string ) {
			const [ year, month, day ] = this.date_day( date ).split( '-' )
			return [ day, month, year ].join( '.' )
		}

		date_day( date: string ) {
			return date.slice( 0, 10 )
		}

		date_shift_text( date: string, shift: ( date: Date )=> Date ) {
			const [ year, month, day ] = this.date_day( date ).split( '-' ).map( Number )
			const next = shift( new Date( year, month - 1, day ) )
			return [
				next.getFullYear(),
				String( next.getMonth() + 1 ).padStart( 2, '0' ),
				String( next.getDate() ).padStart( 2, '0' ),
			].join( '-' )
		}

		chart_date_expression( alias: string ) {
			const group = this.chart_group()
			const date = `${ alias }."_Дата"`
			if( group === 'minute5' ) return `date_trunc( 'hour', ${ date } ) + CAST( FLOOR( date_part( 'minute', ${ date } ) / 5 ) AS BIGINT ) * INTERVAL '5 MINUTE'`
			if( group === 'halfyear' ) return `date_trunc( 'year', ${ date } ) + CASE WHEN month( ${ date } ) > 6 THEN INTERVAL '6 MONTH' ELSE INTERVAL '0 MONTH' END`
			if( group === 'year' ) return `date_trunc( 'year', ${ date } )`
			return `date_trunc( '${ group }', ${ date } )`
		}

		chart_bucket_start( date: string ) {
			const group = this.chart_group()
			const day = this.date_day( date )
			if( group === 'minute5' && this.date_has_time( date ) ) return this.chart_minute5_bucket_sql( date )
			if( group === 'hour' || group === 'minute5' ) return `TIMESTAMP '${ day } 00:00:00'`
			if( group === 'day' ) return `DATE '${ day }'`
			if( group === 'halfyear' ) return `date_trunc( 'year', DATE '${ day }' ) + CASE WHEN month( DATE '${ day }' ) > 6 THEN INTERVAL '6 MONTH' ELSE INTERVAL '0 MONTH' END`
			if( group === 'year' ) return `date_trunc( 'year', DATE '${ day }' )`
			return `date_trunc( '${ group }', DATE '${ day }' )`
		}

		chart_bucket_finish( date: string ) {
			const group = this.chart_group()
			const day = this.date_day( date )
			if( group === 'minute5' && this.date_has_time( date ) ) return this.chart_minute5_bucket_sql( date )
			if( group === 'minute5' ) return `TIMESTAMP '${ day } 23:55:00'`
			if( group === 'hour' ) return `TIMESTAMP '${ day } 23:00:00'`
			return this.chart_bucket_start( date )
		}

		chart_minute5_bucket_sql( date: string ) {
			const timestamp = `TIMESTAMP ${ this.date_sql_text( date ) }`
			return `date_trunc( 'hour', ${ timestamp } ) + CAST( FLOOR( date_part( 'minute', ${ timestamp } ) / 5 ) AS BIGINT ) * INTERVAL '5 MINUTE'`
		}

		chart_metric_sql( date_expression: string ) {
			const table_name = this.tables_and_indexes()
			const filtered_table_name = this.filter_table()
			if( this.chart_metric() === 'Аудитория' ) return `
				SELECT author."Дата", SUM( author."_Аудитория" ) AS "Значение"
				FROM (
					SELECT
						${ date_expression } AS "Дата",
						source."_Автор",
						MAX( source."_Аудитория" ) AS "_Аудитория"
					FROM ${ table_name } source
					JOIN ${ filtered_table_name } filtered USING( "_ID" )
					WHERE ${ this.audience_message_condition( 'source' ) }
					GROUP BY 1, 2
				) author
				GROUP BY 1
			`
			return `
				SELECT
					${ date_expression } AS "Дата",
					${ this.chart_value_expression() } AS "Значение"
				FROM ${ table_name } source
				JOIN ${ filtered_table_name } filtered USING( "_ID" )
				GROUP BY 1
			`
		}

		chart_value_expression() {
			const metric = this.metric_name_from_label( this.chart_metric() )
			if( metric === 'Авторы' ) return `COUNT( DISTINCT source."_Автор" )`
			if( metric === 'Источники' ) return `COUNT( DISTINCT source."Источник" )`
			if( this.metric_names().includes( metric ) ) {
				const table_name = this.tables_and_indexes()
				return `SUM( ${ this.metric_source_expression( table_name, this.data_connection(), metric ) } )`
			}
			return `COUNT(*)`
		}

		@ $mol_mem
		tag_messages_pie() {
			const rows = this.tags().rows
				.map( ([ tag, count ])=> [ String( tag ), Number( count ) ] as const )
				.filter( ([ , count ])=> count > 0 )
			const head = rows.slice( 0, 7 )
			const other = rows.slice( 7 ).reduce( ( sum, row )=> sum + row[1], 0 )
			return other ? [ ... head, [ 'Другие', other ] as const ] : head
		}

	}

}
